module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0147.jpg?v=ff72052f";